
import React from 'react';
import {
	Modal,
	ModalBody,
    // ModalFooter,
    // Spinner
} from 'reactstrap';
// import Spinner from 'react-bootstrap/Spinner'
import LoadingSpinnerSmall from './LoadingSpinnerSmall'

const Loading = ({
	text,
	confirmIsOpen,
	// confirmCloseNative, 
	confirmClose, }) => {
	return (
		<Modal className="modal-loading align-items-center justify-content-center" backdrop="static" size='sm' isOpen={confirmIsOpen} toggle={() => confirmClose()}>
			<ModalBody className="align-self-center">
				<div className="row ml-2">
                    <LoadingSpinnerSmall/>
                    <label className="align-self-center ml-3 mr-3" >
                            {text}
                    </label>
				</div>
			</ModalBody>
		</Modal>
	);
}

export default Loading
